import { Button } from '@mui/material';
import { Translation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
export var unsubscribeAllSuccess = function unsubscribeAllSuccess(t) {
  return {
    severity: 'success',
    message: t("You've been unsubscribed from all notifications"),
    duration: 'medium'
  };
};
export var saveSuccess = function saveSuccess(t) {
  return {
    severity: 'success',
    message: t('Your changes have been saved'),
    duration: 'medium'
  };
};
export var submitFailure = function submitFailure(message, onRetry) {
  return {
    severity: 'error',
    message: message,
    duration: 'medium',
    action: /*#__PURE__*/_jsx(Button, {
      color: "inherit",
      size: "small",
      onClick: onRetry,
      children: /*#__PURE__*/_jsx(Translation, {
        children: function children(t) {
          return t('Retry');
        }
      })
    })
  };
};
export var unsubscribeAllFailure = function unsubscribeAllFailure(onRetry, t) {
  return submitFailure(t('Sorry, we were unable to unsubscribe you'), onRetry);
};
export var saveFailure = function saveFailure(onRetry, t) {
  return submitFailure(t('Sorry, we were unable to save your changes'), onRetry);
};